import store from "./store"

export default function getListenerOptions(additionalOptions = {}) {
  return {
    ...additionalOptions,
    passive: store.getState().sniffer.passiveListeners,
  }
}
